import $ from 'jquery'

function actionsHeaderSearch() {

    console.log('site search helper');

    var searchURL = '/umbraco/api/sitesearch/search';
    var resultsBin = $('#search-results-list');
    var resultsContainer = $('#search-result-container');
    var targetInput = $('#nav-search-bar');

    //making sure that when the user returns to the page the input field has no value 
    targetInput.val('');

    targetInput.keyup(function (e) {

        // Not escape key
        if (e.key != "Escape") {
            var searchText = $(this).val();

            if (searchText.length >= 2) {
                //console.log('Min length search text: ' + searchText);
                handleSearch(e.target);
                //$('#search-result-container').show();
            }
            else if (searchText.length == 0) {
                resultsContainer.hide();
            }
        }

    });

    // When focusing on the search box
    targetInput.one('focus', function(){

        // Close when click outside
        $(document).on('click',  function (event) {
            // If the target is not the container or a child of the container, then process
            // the click event for outside of the container.
            if ($(event.target).closest("#search-result-container").length === 0) {
                resultsContainer.hide();
                console.log('clicked outside element');
            }
        });

        // Close when press escape
        $(document).on('keydown', function (event) {
            if (event.key == "Escape") {
                resultsContainer.hide();
                console.log('Esc key pressed.');
            }
        });

    });


    //disables the enter key so the user won't be sent to the search page
    targetInput.off('keydown').off('blur');


    function handleSearch(calledFrom) {
        //build up a querystring
        var parentDiv = $(calledFrom).closest('.click-through-search');
        var resultHTML = "";
        var searchText = $(parentDiv).find('input[type="text"]:visible').val();
        var params = { searchText: searchText };

        //get any subject areas that match this text search and include them in the filters
        $.ajax({
            url: searchURL,
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(params),
            success: function (data) {

                if (data !== null) {

                    if (data.countResults != 0) {
                        console.log('RESULTS COUNT: ' + data.countResults);

                        $.each(data.results, function (i, item) {
                            console.log('Result Title: ' + item.title);
                            resultHTML += getSearchResultLinks(item.link, item.title);
                        });
                        resultsContainer.show();
                    }
                    else {
                        console.log('NO RESULTS');
                        resultsContainer.hide();
                    }

                    //add links to the container 
                    resultsBin.html(resultHTML);
                }

            }
        });
    }

    function getSearchResultLinks(link, title) {

        return "<div><a href=\"" + link
            + "\" class=\"search-result-link\">"
            + title
            + '<svg class="icon--arrow" aria-hidden="true"><use xlink: href="#icon--arrow"></use ></svg >'
            + "</a></div>";

    }

}

export default actionsHeaderSearch